import { Features, PartnerFeatures } from '../../types/type';

export function isPartnerFeatureEnabled(partnerId: string, featureName: string): boolean {
  let isEnabled = false;
  switch (featureName) {
    case Features.EMERGENCY_SERVICES:
      isEnabled = PartnerFeatures[featureName].includes(partnerId);
      break;
    case Features.WATER_REMOVAL:
      isEnabled = PartnerFeatures[featureName].includes(partnerId);
      break;
    case Features.REPORT_STAGE:
      isEnabled = PartnerFeatures[featureName].includes(partnerId);
      break;
    case Features.DOCUMENT_DAMAGE:
      isEnabled = PartnerFeatures[featureName].includes(partnerId);
      break;
    default:
      break;
  }
  return isEnabled;
}

export function isPropertyFNOLEnabled() {
  const isPropertyFNOLEnabled = true;
  return isPropertyFNOLEnabled;
}
